import './custom_assignments' // Defines ALL (window-)global custom vars/consts: ensure to correctly overwrite below
import { overwriteColors } from './colors_theben'
import { overwriteCoreuiDeviceIcons, overwriteIcons } from './icons_theben'

const EXTERNAL_LINKS = ['www.theben.de', 'www.theben.fr']
window.LegacyApp.EXTERNAL_LINKS = EXTERNAL_LINKS

overwriteColors()
overwriteIcons()
overwriteCoreuiDeviceIcons()
